import { Reply } from '../types/post';

/**
 * Select 3 preview comments based on:
 * 1. Most popular (highest likes)
 * 2. Most controversial (highest dislikes OR closest like/dislike ratio)
 * 3. Random
 */
export function selectPreviewComments(replies: Reply[]): Reply[] {
  if (!replies || replies.length === 0) return [];
  if (replies.length <= 3) return replies;

  const selected: Reply[] = [];
  const available = [...replies];

  // 1. Most popular (highest likes)
  const mostPopular = available.reduce((prev, curr) =>
    (curr.likes > prev.likes) ? curr : prev
  );
  selected.push(mostPopular);
  available.splice(available.indexOf(mostPopular), 1);

  // 2. Most controversial (highest dislikes, or if no dislikes, smallest like-dislike difference)
  const mostControversial = available.reduce((prev, curr) => {
    const prevScore = prev.dislikes > 0 ? prev.dislikes : Math.abs(prev.likes - prev.dislikes);
    const currScore = curr.dislikes > 0 ? curr.dislikes : Math.abs(curr.likes - curr.dislikes);
    return currScore > prevScore ? curr : prev;
  });
  selected.push(mostControversial);
  available.splice(available.indexOf(mostControversial), 1);

  // 3. Random
  if (available.length > 0) {
    const randomIndex = Math.floor(Math.random() * available.length);
    selected.push(available[randomIndex]);
  }

  return selected;
}
